export const convertArrayToObject = (state, array) => {
  var objects = state;

  for (let i = 0; i < array.length; i++) {
    let width = array[i].width;

    if (width && array[i].resizable) {
      objects[array[i].key] = width;
    }
  }
  
  return objects;
};